var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgEyeFill = function SvgEyeFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.37 11.64Q15.51 7.73 12 7.73t-7.37 3.91a.35.35 0 000 .47q3.62 4.16 7.37 4.16t7.38-4.16a.35.35 0 00-.01-.47zM12 14.14A2.13 2.13 0 1114.13 12 2.13 2.13 0 0112 14.14z",
    fill: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.8c-2.65 0-5.27-1.46-7.78-4.34a.88.88 0 010-1.2C6.92 8.57 9.52 7.2 12 7.2s5.08 1.37 7.75 4.07a.88.88 0 010 1.2c-2.48 2.87-5.1 4.33-7.75 4.33zm-6.86-4.91c4.54 5.1 9.2 5.1 13.73 0-2.42-2.4-4.73-3.62-6.87-3.62s-4.45 1.22-6.86 3.62zM12 14.67A2.67 2.67 0 1114.67 12 2.67 2.67 0 0112 14.67zm0-4.27a1.6 1.6 0 101.6 1.6 1.6 1.6 0 00-1.6-1.6z"
  })));
};

export default SvgEyeFill;